/* eslint-disable */
/*!
   _____ ______ __  __ _    _  _____ __  __ ______ _____  
  / ____|  ____|  \/  | |  | |/ ____|  \/  |  ____|  __ \ 
 | |  __| |__  | \  / | |__| | (___ | \  / | |__  | |  | |
 | | |_ |  __| | |\/| |  __  |\___ \| |\/| |  __| | |  | |
 | |__| | |____| |  | | |  | |____) | |  | | |____| |__| |
  \_____|______|_|  |_|_|  |_|_____/|_|  |_|______|_____/                                                                                                                                                                                                                                                                                                   
=========================================================
* GEMHSMED UI - v2.0.0
=========================================================

* Copyright 2024 GEMHS (https://gemhs.net/)

* Designed and Coded by GEMHS

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 

*/

import {
    Box,
    Text,
    Heading,
    List,
    ListItem,
    Link,
    VStack,
} from "@chakra-ui/react";

const Terms = () => {
    return (
        <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
            <VStack spacing={4} align="stretch">
                <Heading as="h1" size="xl">
                    Terms of Use
                </Heading>

                <Text fontSize="md">
                    Welcome to GEMHS Medical Patient Record System. These Terms
                    of Use govern your use of our software and services,
                    including any updates and new features that may be added
                    periodically. The software is intended for use by authorized
                    healthcare professionals within healthcare facilities that
                    have purchased a software license.
                </Text>

                <Heading as="h2" size="lg">
                    1. Acceptance of Terms
                </Heading>
                <Text fontSize="md">
                    By accessing and using our software, you agree to these
                    Terms of Use, our Privacy Policy, and any additional terms
                    applicable to certain modules or features. If you do not
                    agree to these terms, do not use the software.
                </Text>

                <Heading as="h2" size="lg">
                    2. Software License
                </Heading>
                <Text fontSize="md">
                    Each healthcare facility will receive credentials to access
                    and use the software upon purchasing a license. These
                    credentials may be altered within the system by authorized
                    users. The license is billed on a subscription basis
                    (monthly, quarterly) as agreed upon in the user-client
                    contract.
                </Text>

                <Heading as="h2" size="lg">
                    3. Use of Software
                </Heading>
                <List spacing={2}>
                    <ListItem>
                        Enter and manage patient and healthcare data accurately.
                    </ListItem>
                    <ListItem>
                        Comply with all applicable laws, including HIPAA and
                        GDPR.
                    </ListItem>
                    <ListItem>
                        Use the software in a professional manner consistent
                        with healthcare standards, including adherence to ADA
                        codes in dental services.
                    </ListItem>
                </List>

                <Heading as="h2" size="lg">
                    4. Data Management
                </Heading>
                <Text fontSize="md">
                    All patient data entered into the system is stored securely
                    and managed in compliance with applicable data protection
                    regulations. Users with administrative rights have the
                    authority to delete any data within the system, while normal
                    users may only modify or delete data they have entered.
                </Text>

                <Heading as="h2" size="lg">
                    5. Export and Continuity
                </Heading>
                <Text fontSize="md">
                    Users wishing to discontinue use of the software can export
                    their data in CSV or Excel formats. We strive to ensure
                    continuity of service but reserve the right to conduct
                    system maintenance, which may temporarily affect
                    accessibility.
                </Text>

                <Heading as="h2" size="lg">
                    6. Ownership and Intellectual Property
                </Heading>
                <Text fontSize="md">
                    All rights in and to the software and its components belong
                    to GEMHS. The software is provided under license and is not
                    sold. Users are granted a non-exclusive, non-transferable
                    license to use the software per the terms of their
                    user-client agreement.
                </Text>

                <Heading as="h2" size="lg">
                    7. Termination and Suspension
                </Heading>
                <Text fontSize="md">
                    GEMHS reserves the right to terminate or suspend access to
                    the software if any user fails to comply with these Terms of
                    Use. Prior notice will be provided where feasible.
                </Text>

                <Heading as="h2" size="lg">
                    8. Limitation of Liability
                </Heading>
                <Text fontSize="md">
                    GEMHS will not be liable for any direct, indirect,
                    incidental, special, consequential, or exemplary damages
                    resulting from the use of or inability to use the services.
                </Text>

                <Heading as="h2" size="lg">
                    9. Changes to Terms
                </Heading>
                <Text fontSize="md">
                    GEMHS reserves the right to modify these Terms of Use at any
                    time. Users will be notified of any significant changes and
                    continued use of the software will constitute acceptance of
                    the new terms.
                </Text>

                <Heading as="h2" size="lg">
                    10. Governing Law
                </Heading>
                <Text fontSize="md">
                    These Terms of Use shall be governed by and construed in
                    accordance with the laws of the jurisdiction in which GEMHS
                    is headquartered, without regard to its conflict of law
                    provisions.
                </Text>

            </VStack>
        </Box>
    );
};

export default Terms;
